<template>
  <div class="col backgroundForm">
  
  <div class="form-row" >
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label for="capitanias">Capitania</label>
        <select name="captain" id="captain" class="form-control" v-model="captain_select_ordop">
          <option :value="{id:0}">TODAS LAS CAPITANIAS</option>
          <option v-for="p in ports" :key="p.id" :value="p">{{p.name_port }}</option>
        </select>
      </div>
    </div>
    <div class="col-12 col-md-2">
      <div class="form-group">
        <label for="capitanias">Fecha Inicio</label>
        <datetime v-model="date_select.init" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione la Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
      </div>
    </div>
    <div class="col-12 col-md-2">
      <div class="form-group">
          <label for="capitanias">Fecha Final</label>
          <datetime v-model="date_select.end" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione la Fecha" title="Fecha de Final" value-zone="America/La_Paz"></datetime>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="form-group">
          <label for="capitanias">Tipo Resultado</label>
          <select name="type_ordop" class="form-control" id="type_ordop" v-model="result_select" >
            <option :value="{id:0}">TODOS LOS RESULTADOS</option>
            <option v-for="or in types_ordop" :value="or" :key="or.id">{{or.detail}}</option>
          </select>
      </div>
    </div>
    

    <div class="col-12" align="center">
        <button class="btn btn-info" @click="mViewMap"><font-awesome-icon icon="sync-alt" /> Cargar</button>
    </div>                        
  </div>
  
  <div class="row">

    <div class="col-12 col-md-8">
    <CargarMapa v-if="renderComponent"
      :configMapa="configMapa"
      apiKey="AIzaSyDQ4Ii0YR8i1LCRjgK9rfoDxVvE2S9__tU"
    >

      <template slot-scope="{ google, map }">
        <Marcadores
          v-for="marker in cLocationCaptains"
          :key="marker.id"
          :marker=marker
          :google="google"
          :map="map"
        />
      </template>

    </CargarMapa>
    </div>
    <div class="col-12 col-md-4" v-if="tables_color !== null" v-html="tables_color">
      
    </div>
  </div>

  <br><br>
    <div v-if="table_captains_detail!==null">
      <div class="col-12 col-md-4 offset-md-8 d-print-none">
            <button class="btn btn-outline-primary" @click="mCopyToClipboard('printTable')">
                <font-awesome-icon icon="copy" /><br>copiar 
            </button>
      </div> 
      <div class="table-responsive d-print-block landscape" id="printTable">
          <h5 align="center"><b>Dirección General de Capitanías de Puerto</b><br>
            {{ date_init_aux }} al {{ date_end_aux }}</h5>
          <table class="table table-bordered" v-html="table_captains_detail" >
          </table>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  const qs= require('qs');

  import modalLoading from '../modal/modalLoading';

  import CargarMapa from "../maps/LoadMap";
  import Marcadores from "../maps/MarksMaps";
  

  import { configMapa } from "@/constants/configMapaRead";
  import MarksMapsVue from '../maps/MarksMaps.vue';
  

  export default {
    components: {
      CargarMapa,
      Marcadores
    },
    mounted(){
      this.callCaptains();
    },
    data() {
      return {
        showMap:false,
        send_dispatch:true,
        renderComponent:false,
        ports:[],
        captain_select_ordop:{id:0, name_port:'TODAS'},
        date_select:{
          init:null,
          end:null
        },
        result_select:{id:0, detail:'TODAS'},
        types_ordop:[],
        results_marks:[],
        results_color:[],
        tables_color:null,
        date_init_aux:null,
        date_end_aux:null,
        table_captains_detail:null
      }
    },
    methods:{
      mCopyToClipboard(elemento) {
            var $temp = $("<input>")
            $("body").append($temp);
            // console.log($(`#${elemento}`));
            $temp.val($(`#${elemento}`).html()).select();
            document.execCommand("copy");
            $temp.remove();
            toastr.info('Tabla copiada al portapapeles', 'Archivo copiado')
      },
      mValidateForm(){
        let adi=this.date_select.init.split('T');
        this.date_select.init=adi[0];

        if( this.date_select.init === null || !(this.date_select.init.length === 10) ){
            toastr.error('La fecha de Inicio es incorrecta', 'Error');
              return false;
        }

        let ade=this.date_select.end.split('T');
        this.date_select.end=ade[0];

        if( this.date_select.end === null || !(this.date_select.end.length === 10) ){
            toastr.error('La fecha de Final es incorrecta', 'Error');
              return false;
        }
        return true;
      },
      async mViewMap(){
        // solicitamos los datos para consultar al sistema y armar los puntos
        if(this.mValidateForm()){
          
          let res=await axios.get(`getLocationOrdops/${this.captain_select_ordop.id}/${this.date_select.init}/${this.date_select.end}/${this.result_select.id}?api_token=${Vue.auth.getToken()}`);
          console.log(res);
          this.date_init_aux=this.$dateWrite(this.date_select.init);
          this.date_end_aux=this.$dateWrite(this.date_select.end);
          if(res.data.length > 0){
            this.results_marks=res.data;
            this.showMap=true;
            this.mGenerateMark();
            this.mGetDtsMatrizDetail();
            this.forceRerender();
          }else{
            toastr.info('No se encontraron resultados')
          }
        }
                
      },
      mConvertRadial(coord=-1){
                
        let coordenada_aux=coord<0 ? coord * -1: 0;

        let entero=0;
        let minuto=0;
        let minuto_aux=0;
        let segundo=0;

        let coordenada_end=null;

        entero=Math.trunc(coordenada_aux);
        minuto_aux=coordenada_aux-entero;
        minuto=Math.trunc(minuto_aux*60);

        segundo=Math.trunc((minuto-minuto_aux)*60);

        coordenada_end=`${entero}° ${minuto}' ${segundo}''`;
        return coordenada_end;

      },
      forceRerender() {
            // Remove my-component from the DOM
            this.renderComponent = false;

            // also use nextTick this way
            this.$nextTick().then(() => {
                // Add the component back in
                this.renderComponent = true;
            });
      },
      async callCaptains(){
        
        let cp=await axios.get(`getPortsComplete?api_token=${Vue.auth.getToken()}`);
        let od=await axios.get(`globals/ordop?api_token=${Vue.auth.getToken()}`);

        // console.log(cp);
        this.types_ordop=od.data;       

        this.ports=cp.data;
         
      },
      genHexColor(){
        let colors = new Array(16);
        colors[0]="0";
        colors[1]="1";
        colors[2]="2";
        colors[3]="3";
        colors[4]="4";
        colors[5]="5";
        colors[6]="6";
        colors[7]="7";
        colors[8]="8";
        colors[9]="9";
        colors[10]="a";
        colors[11]="b";
        colors[12]="c";
        colors[13]="d";
        colors[14]="e";
        colors[15]="f";

        let digit = new Array(5);
        let color="";
        for (let i=0;i<6;i++){
            // digit[i]=colors[Math.round(Math.random()*16)];
            color = color+colors[Math.round(Math.random()*15)];
        }

        return color;
      },
      mAssignColorOrdops(){
        this.results_color=[];
        this.types_ordop.forEach(to=>{
            
            let colt={
              color:this.genHexColor(),
              type:to.id,
              detail:to.detail,
              quantity:0
            }
            this.results_color.push(colt);
        })
      },
      mGenerateTableColor(){
        // console.log(this.results_color);
        this.tables_color=null;
        let tba=`<table class="table table-sm">
                  <tbody>`;
        console.log(this.results_color);
        this.results_color.forEach(dt =>{
          let contVeces=0;
          this.results_marks.forEach((rest, index) => {
              // aqui el resultado lo vamos sumando al registro que ya cuente en el arreglo
              if(rest.type===dt.type){
                contVeces+=1;
              }
          })

          tba+=`<tr>
                  <td>${dt.detail}</td>
                  <td width="8%">${contVeces}</td>
                  <td width="5%" style="background-color:#${dt.color}"></td>
                </tr>`;
        });
        
        tba+=`</tbody>
        </table>`;
        this.tables_color=tba;
      },
      async mGetDtsMatrizDetail(){
            
                this.table_captains_detail='';
                let resultsOrdops= await axios.get(`ordopsResults/${this.captain_select_ordop.id}/${this.date_select.init}/${this.date_select.end}/${this.result_select.id}?api_token=${Vue.auth.getToken()}`);
                // console.log(resultsOrdops);
                // console.log(this.list_type_result);
                this.results_ordop=resultsOrdops.data;
                this.results_color.forEach((ortype)=>{
                    let detalle_fila='';
                    // let color_ccpp=this.mRandomColor();
                    detalle_fila+=`<tr><td class="align-middle" style="text-align:center; background-color:#${ortype.color}"><h4>${ortype.detail}</h4></td></tr>`;
                    let contRes=0;
                    this.results_ordop.forEach((resor)=>{
                        if(resor.tipo_resultado===ortype.type){
                            contRes+=1;
                            let militaryDate=this.$dateMilitary(resor.fecha_conlusion, resor.hora_fin)
                            detalle_fila+=`<tr><td style="text-align:justify;">
                              <div class="row">
                                <div class=" col-12 col-md-10 offset-md-1">
                                  <div class=" col-md-3 card border-0" style="float:left; background-color: transparent;">
                                    <img src="data:image/${resor.extention};base64,${resor.path}"  class="card-img-top" >
                                    <div class="card-body text-center">
                                      <h5 class="card-title mb-0"><span style="color:red;">${resor.name_port}</span></h5>
                                      <div class="card-text text-black-50"><span style="color:red;"> ${resor.titulo_ordop}</span></div>
                                    </div>
                                  </div>
                                  <span>En FH: ${militaryDate} ${resor.hecho}<br>${resor.acciones_tomadas}</span>
                                </div>
                              </div>
                              </td></tr>`;
                        }
                    })
                    if(contRes===0){
                        detalle_fila+=`<tr><td style="text-align:center;"><h5>SIN REGISTROS</h5></td></tr>`;
                    }
                    this.table_captains_detail+=detalle_fila;
                })
      },
      mGenerateMark(){
        this.mAssignColorOrdops();
        this.$store.dispatch('sGoogleMaps/deleteMarkersCaptains', true);
        let marksCaptain=[];
        let myColour=this.genHexColor();
        // aqui por cada tipo de prueba generar un color de prueba
        let myTitle=null;
        // let myLetter=myTitle.substring(0,1);
        // volvemos a generar la tabla
        this.mGenerateTableColor();
        this.results_marks.forEach((reso, index) => {
              // aqui el resultado lo vamos sumando al registro que ya cuente en el arreglo

              let indexColor=this.results_color.findIndex(val => val.type === reso.type );
              this.results_color[indexColor].quantity+=1;

              let colorPoint=this.results_color[indexColor].color;
              let lat=this.mConvertRadial(reso.latitud);
              let lon=this.mConvertRadial(reso.longitud);
              // console.log('https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld='+myLetter+'|'+myColour+'|000000');
              let location={
                id:index,
                position:{lat:parseFloat(reso.latitud), lng:parseFloat(reso.longitud)},
                // icon:'http://maps.google.com/mapfiles/ms/icons/purple.png',
                icon:'https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=|'+colorPoint+'|000000',
                size:{width:20, height:30},
                title:`${reso.titulo_ordop}`,
                description:`<div id="content" class="card">
                              <div class="card-body">
                                <h6 class="card-title">${reso.category} ${reso.name_port}</h6>
                                <p class="card-text"><b>ORDOP:</b> ${reso.titulo_ordop} - ${reso.result}</p>
                                <p class="card-text"><b>Sector:</b> ${reso.sector}<br>${reso.description}</p>
                                <p class="card-text"><b>Latitud:</b> ${lat}  <b>Longitud:</b> ${lon}</p>
                              </div>
                            </div>`,
                jurisdiccion:[]
              }
              marksCaptain.push(location);
              // location.jurisdiccion.push({lat:parseFloat(cap.latitud), lng:parseFloat(cap.longitud)});
              // console.log(marksCaptain);
            });

          this.$store.dispatch('sGoogleMaps/addMarkersCaptains', marksCaptain);
      }
    },
    computed: {
      configMapa() {
        return {
          ...configMapa,
          center: this.mapCenter
        };
      }, 
      cDtsUser(){
        return this.$store.getters.getUserState;
      },     
      cLocationCaptains(){
        // return this.$store.getters.getLocation;
        // console.log(this.$store.getters['sGoogleMaps/getLocation'].lat);
        return this.$store.getters['sGoogleMaps/getMarkersCaptain'];
      },
      mapCenter() {
        // return this.markers[0].position;
        return this.cLocationCaptains[0].position;
      },
    }
  };
  
</script>


// WEBPACK FOOTER //
// src/components/ordop/MapsOrdopPoint.vue